import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@apps/ui/global';

import { App } from './app/App';
import { initSentry } from './app/sentry';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
